export async function loadAuthState() {
  try {
    const response = await fetch('/actions/users/session-info', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Session request failed: ${response.status}`);
    }

    const session = await response.json();

    return !session.isGuest;
  } catch (error) {
    console.error('Could not retrieve the Craft session:', error);

    return false;
  }
}

const authStateService = Object.freeze({
  loadAuthState,
});

if (typeof window !== 'undefined') {
  window.authStateService = authStateService;
}

export default authStateService;
